'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import Select from 'react-select';
import { getOptionMap } from '../../../utils/selectOption';
import { wrapField } from '../../hooks/useForm';
import { InputVariantEnum } from '../TopLabel';
import SelectInputContainer from './SelectContainer';
import styles from './selectInput.module.scss';
const SelectInput = React.forwardRef((_a, ref) => {
    var { id, label, options, className, value, error, isSearchable, onChange, onBlur, disabled, backgroundColor, narrow, capitaliseOptions = true, variant = InputVariantEnum.DEFAULT } = _a, props = __rest(_a, ["id", "label", "options", "className", "value", "error", "isSearchable", "onChange", "onBlur", "disabled", "backgroundColor", "narrow", "capitaliseOptions", "variant"]);
    const [focused, setFocused] = useState(false);
    const valueToOption = useMemo(() => getOptionMap(options), [options]);
    const selectId = `select${id}`;
    const placeholder = {
        [InputVariantEnum.DEFAULT]: focused ? undefined : label,
        [InputVariantEnum.LABEL_OUTSIDE]: undefined,
    };
    return (<SelectInputContainer error={error} className={className} focused={focused} hasValue={!!value} backgroundColor={backgroundColor} options={options} id={selectId} label={label} disabled={disabled} narrow={narrow} variant={variant}>
        <Select instanceId={id} name={id} inputId={selectId} onFocus={() => setFocused(true)} onBlur={() => {
            setFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }} options={options} placeholder={placeholder[variant]} value={value ? valueToOption.get(value) : null} className={classNames(styles.reactSelectContainer, {
            [styles.error]: !!error,
            [styles.focused]: focused,
            [styles.capitalOptions]: capitaliseOptions,
        })} classNamePrefix='reactSelect' onChange={(option) => {
            var _a;
            if (option == null) {
                onChange(null);
                return;
            }
            onChange((_a = option.value) !== null && _a !== void 0 ? _a : '');
        }} isMulti={false} isSearchable={isSearchable} ref={ref} isDisabled={disabled} {...props}/>
      </SelectInputContainer>);
});
SelectInput.displayName = 'SelectInput';
export const SelectInputField = wrapField(SelectInput);
export default SelectInput;
